import Grid from "@mui/material/Grid";
// import Tooltip from "@mui/material/Tooltip";
// import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Card from "@mui/material/Card";
import {useEffect, useState} from "react";
// import Autocomplete from "@mui/material/Autocomplete";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import MDButton from "../../../../components/MDButton";
import SelectDate from "./components/dateselect";
// import SelectTime from "./components/timeselect";
import BookingData from "./components/bookingdata";
import ReviewData from "./components/reviewdata";
import Account from "../../../applications/wizard/components/Account";
import * as PropTypes from "prop-types";
import Ads from "../../ads";
import QuestionApprove from "../questions/components/question_approve";
import {useLocation, useNavigate} from "react-router-dom";
import AmenitiesService, {getAmenityInfo} from "../../../../services/amenities.service";
import ReCAPTCHA from "react-google-recaptcha";


import LoadingOverlay from 'react-loading-overlay';
import MDSnackbar from "../../../../components/MDSnackbar";
import PaymentService from "../../../../services/payment.service";
import {createRef} from "react";
import AuthService from "../../../../services/auth.service";
const recaptchaRef = createRef();

function getCurrentDateTimeLocalValue() {
  const now = new Date();
  const offsetMs = now.getTimezoneOffset() * 60000;
  return new Date(now.getTime() - offsetMs).toISOString().slice(0, 16);
}

function isDevBookingHost() {
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1" || host.includes(".dev.");
}

function getSteps(hasQuestions, showReserveStep) {
  // if (isMobile){
  // }else{
  //     return ["1. Select Date", "2. Select Time", "3. Your Data", "4. Questions", "4. Review and payment"];
  // }
  //
    const count = (showReserveStep ? 3 : 2) + (hasQuestions ? 2 : 1);
    return Array.from({ length: count }, (_, index) => (index + 1).toString());
}
// function getSteps() {
//
// }
function onChange(value) {
  // console.log("Captcha value:", value);
}


function AmenitiesBook() {
  const [activeStep, setActiveStep] = useState(0);
  const [values, setValues] = useState({'name': '...'});
  const isDevHost = isDevBookingHost();
  const [debugNow, setDebugNow] = useState(getCurrentDateTimeLocalValue());
  const hasQuestions = Array.isArray(values.questions) && values.questions.length > 0;
  const showReserveStep = AuthService.getUserRole() !== "member";
  const steps = getSteps(hasQuestions, showReserveStep);
  const isLastStep = activeStep === steps.length - 1;
  const search = useLocation().search;

  const handleNext = () => {
    setValues({...values, isValid:false, autoNext:false});
    setActiveStep(activeStep + 1);
  };
  const handleBack = () => {
    setValues({...values, isValid:true, autoNext:false});
    setActiveStep((currentStep) => Math.max(currentStep - 1, 0));
  };
  if (values.autoNext !== undefined &&
      values.autoNext !== null &&
      values.autoNext === true){
      handleNext();
  }
  function getStepContent(stepIndex) {
      if (showReserveStep) {
        switch (stepIndex) {
          case 0:
            return <BookingData values={values} setValues={setValues} refreshAmenityForUser={refreshAmenityForUser}/>;
          case 1:
            return <SelectDate values={values} setValues={setValues} />;
          case 2:
            return <Account values={values} setValues={setValues} />;
          case 3:
            return hasQuestions
                ? <QuestionApprove values={values} setValues={setValues}/>
                : <ReviewData values={values} setValues={setValues} />;
          case 4:
            return <ReviewData values={values} setValues={setValues} />;
          default:
            return null;
        }
      }
      switch (stepIndex) {
        case 0:
          return <SelectDate values={values} setValues={setValues}  />;
        case 1:
          return <Account values={values} setValues={setValues} />;
        case 2:
          return hasQuestions
              ? <QuestionApprove  values={values} setValues={setValues}/>
              : <ReviewData values={values} setValues={setValues} />;
        case 3:
          return <ReviewData values={values} setValues={setValues} />;
        default:
          return null;
      }
    }
    const [infoSB, setInfoSB] = useState(false);
    const [errorSB, setErrorSB] = useState(false);
    const [errorMessage, SetErrorMessage] = useState("");
    const renderSB = (
        <div>
            <MDSnackbar
              color="success"
              icon="check"
              title="Booking Confirmed!"
              content="Your booking has been confirmed successfully. You will receive a confirmation email shortly."
              dateTime=""
              open={infoSB}
              onClose={()=>setInfoSB(false)}
              close={()=>setInfoSB(false)}  />

            <MDSnackbar
              color="error"
              icon="error"
              title="Amenity System"
              content={errorMessage}
              dateTime=""
              open={errorSB}
              onClose={()=>setErrorSB(false)}
              close={()=>setErrorSB(false)}/>
        </div>
    ); 
  const navigate = useNavigate();
  const [activeLoading, setActiveLoading] = useState(false);
  const finishAndPayment = () => {

    const id = new URLSearchParams(search).get('id');
    setActiveLoading(true);
    // alert("createBooking");

    // TODO: Re-enable Stripe payment flow when ready
    // For now, create booking directly for all amenities (paid and free)
    // Payment can be collected separately/offline for paid amenities

    // Format booking data to match backend expectations
    const bookingData = {
      id: parseInt(id),  // Backend expects 'id' as AmenityID
      SelectedDate: {    // Backend expects capital 'S'
        date: values.selectedDate?.date || ''
      },
      start_time: values.start_time,
      end_time: values.end_time,
      completeName: values.completeName || '',
      email: values.email || '',
      phone: values.phone || '',
      user_id: values.selected_member?.id || values.user_id || 0,
      minors: values.minors || 0,
      guests: values.guests || 0,
      for_other: values.for_other || false,
      debug_now: isDevHost ? debugNow : ""
    };

    AmenitiesService.createBooking(id, bookingData)
      .then(value => {
          setInfoSB(true);
          setActiveLoading(false);
          navigate("/dashboard");
      }).catch(reason => {
          const apiMessage = reason.response?.data?.status || "Failed to create booking. Please try again.";
          SetErrorMessage(apiMessage);
          setErrorSB(true);
          setActiveLoading(false);
          const shouldRefreshAvailability =
            reason.response?.status === 409 &&
            !apiMessage.toLowerCase().includes("staff booking limit");

          if (shouldRefreshAvailability) {
            refreshAmenityForUser(values.for_other ? values.user_id : null, {
              for_other: values.for_other || false,
              selected_building: values.selected_building || null,
              selected_member: values.selected_member || null,
              user_id: values.user_id || 0,
              completeName: values.completeName || "",
              email: values.email || "",
              phone: values.phone || "",
            });
          }
      });

    /* STRIPE PAYMENT FLOW - Enable when Stripe integration is complete
      if (values.price > 0){
        PaymentService.createOrder(id)
        .then((value)=>{
            window.location = value["url"]
        }).catch((reason)=>{
            SetErrorMessage(reason.response.data.status);
            setErrorSB(true);
            setActiveLoading(false);
        });
      }else{
          AmenitiesService.createBooking(id, values)
            .then(value => {
                setInfoSB(true);
                setActiveLoading(false);
                navigate("/dashboard");
            }).catch(reason => {
                SetErrorMessage(reason.response.data.status);
                setErrorSB(true);
                setActiveLoading(false);
            });
      }
    */

  };

  const getAmenityInfo = (overrideDebugNow = debugNow) => {
    // alert("getAmenityInfo");
    setActiveLoading(true);
    const id = new URLSearchParams(search).get('id');
    const userid = new URLSearchParams(search).get('userid');
    if(userid !== undefined && userid !== null){
          AmenitiesService.getAmenityInfoCustomUser(id, userid, isDevHost ? overrideDebugNow : "")
        .then(value => {
            console.log(value.data)
            setValues(value.data);
            setActiveLoading(false);
        }).catch(reason => {
            SetErrorMessage(reason.response.data.status);
            setErrorSB(true);
            setActiveLoading(false);
        });
    }else{
          AmenitiesService.getAmenityInfo(id, isDevHost ? overrideDebugNow : "")
        .then(value => {
            console.log(value.data)
            setValues(value.data);
            setActiveLoading(false);
        }).catch(reason => {
            SetErrorMessage(reason);
            setErrorSB(true);
            setActiveLoading(false);
        });
    }

  }

  const refreshAmenityForUser = (userid = null, preserveValues = {}) => {
    const id = new URLSearchParams(search).get('id');
    const request = userid
      ? AmenitiesService.getAmenityInfoCustomUser(id, userid, isDevHost ? debugNow : "")
      : AmenitiesService.getAmenityInfo(id, isDevHost ? debugNow : "");

    setActiveLoading(true);
    request
      .then((response) => {
        setValues({
          ...response.data,
          ...preserveValues,
          selectedDate: undefined,
          start_time: undefined,
          end_time: undefined,
          isValid: false,
          autoNext: false,
        });
        setActiveStep(showReserveStep ? 1 : 0);
        setActiveLoading(false);
      })
      .catch((reason) => {
        SetErrorMessage(reason.response?.data?.status || "Could not load amenity availability");
        setErrorSB(true);
        setActiveLoading(false);
      });
  };

  useEffect(() => {
    getAmenityInfo()
  },[])

  const applyDebugNow = () => {
    setActiveStep(0);
    setValues({...values, isValid:false, autoNext:false, selectedDate: undefined, start_time: undefined, end_time: undefined});
    getAmenityInfo(debugNow);
  };


  const renderMain = () => (
      <LoadingOverlay active={activeLoading} spinner text='Creating your booking...'>
        {renderSB}
        <ReCAPTCHA
          ref={recaptchaRef}
          size="invisible"
          sitekey="6LfDYAQlAAAAAMw3XZ3XxVmcV_LJGxYrSAzZ60aF"
          onChange={onChange}
        />

        <Grid xs={12} lg={12}>
          <MDBox mt={0.1} mb={9}>
            <Grid container justifyContent="center">
              <Grid item xs={12} lg={12}>
              <Ads type={"header"} />
                <MDBox mt={6} mb={8} textAlign="center">
                  <MDBox mb={1}>
                    <MDTypography variant="h2" fontWeight="bold">
                      Booking {values.name}
                    </MDTypography>
                  </MDBox>
                  <MDTypography variant="h3" fontWeight="regular" color="secondary">
                    {values.description}
                  </MDTypography>
                </MDBox>

                {isDevHost && (
                  <Card>
                    <MDBox p={2} mb={2}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={4}>
                          <MDTypography variant="h6" fontWeight="bold">
                            Dev booking clock
                          </MDTypography>
                          <MDTypography variant="caption" color="text">
                            Used only on dev/local to test booking window dates.
                          </MDTypography>
                        </Grid>
                        <Grid item xs={12} md={5}>
                          <input
                            type="datetime-local"
                            value={debugNow}
                            onChange={(event) => setDebugNow(event.target.value)}
                            style={{
                              width: "100%",
                              padding: "12px",
                              border: "1px solid #d2d6da",
                              borderRadius: "8px",
                              fontSize: "14px",
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <MDButton color="info" onClick={applyDebugNow} fullWidth>
                            Apply Test Time
                          </MDButton>
                        </Grid>
                      </Grid>
                    </MDBox>
                  </Card>
                )}

                <Card>

                  <MDBox mt={-3} mb={3} mx={2}>
                    <Stepper activeStep={activeStep} alternativeLabel>
                      {steps.map((label) => (
                        <Step  key={label}>
                          <StepLabel  ><h2>{label}</h2></StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </MDBox>
                  <MDBox p={2}>
                    <MDBox>
                      {getStepContent(activeStep)}
                      <MDBox mt={3} width="100%" display="flex" justifyContent="space-between">
                        {activeStep === 0 ? (
                          <MDBox />
                        ) : (
                          <MDButton variant="gradient" color="light" size="large" onClick={handleBack}>
                            Back
                          </MDButton>
                        )}
                        <MDButton
                          variant="gradient"
                          color="success"
                          size="large"
                          disabled={!values.isValid}
                          onClick={!isLastStep ? handleNext : finishAndPayment}
                        >

                          {isLastStep ? (values.price > 0 ? "Confirm And Proceed to Checkout" : "Confirm And Book") : "Next"}
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              <Ads type={"footer"} />
              </Grid>
            </Grid>
          </MDBox>

        </Grid>
      </LoadingOverlay>
  );
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {renderMain()}
      <Footer />
    </DashboardLayout>
  );
}

export default AmenitiesBook;
